import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import {
  CreateObjectStepId,
  createObjectSessionStore,
} from 'entities/kyrgyzstan/model/create-object'

import { ButtonContinue } from 'shared/ui/bottom-continue'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Paper } from 'shared/ui/paper'

import { IntroItem } from './ui/intro-item'
import { PolicyAgreement } from './ui/policy-agreement'

import { items } from './model/items'
import s from './styles.module.scss'

const KyrgyzstanCreateObjectIntroPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isAccepted, setIsAccepted] = useState(false)

  const handleConfirm = () => {
    if (!isAccepted) {
      return
    }

    createObjectSessionStore.reset()

    navigate(
      RoutingPaths.kyrgyzstan.objects.create.step.path(
        CreateObjectStepId.ObjectType,
      ),
    )
  }

  const handleCheckboxChange = () => {
    setIsAccepted((prev) => !prev)
  }

  return (
    <main className={s.page}>
      <HeaderGoBack
        variant="grey"
        buttonWhite
        title={t('kyrgyzstan_block.create_object.intro.header')}
      />
      <Paper
        padding={[12, 16]}
        className={s.intro}
      >
        <h1 className={clsx(s.title, 'bold-18')}>
          {t('kyrgyzstan_block.create_object.intro.title')}
        </h1>
        <div className={s.content}>
          {items.map((item, index) => (
            <IntroItem
              key={item.id}
              index={index}
              title={t(item.titleKey)}
              description={t(item.descriptionKey)}
              img={item.img}
            />
          ))}
        </div>
      </Paper>

      <ButtonContinue
        disabled={!isAccepted}
        onClick={handleConfirm}
        className={clsx(s.button, 'semi-bold-17')}
        slot={
          <PolicyAgreement
            isAccepted={isAccepted}
            onToggle={handleCheckboxChange}
          />
        }
      >
        {t('kyrgyzstan_block.create_object.intro.button')}
      </ButtonContinue>
    </main>
  )
})

export default KyrgyzstanCreateObjectIntroPage
